import { request } from '../axios/request';

import {
  FETCH_CARGO_COMPANIES_PENDING,
  FETCH_CARGO_COMPANIES_REJECTED,
  FETCH_CARGO_COMPANIES_FULFILLED,
} from '../constants/cargoCompanies';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_CARGO_COMPANIES_PENDING,
});

const fulfilled = (data) => ({
  type: FETCH_CARGO_COMPANIES_FULFILLED,
  data,
});

const rejected = (error) => ({
  type: FETCH_CARGO_COMPANIES_REJECTED,
  error,
});

export const fetchCargoCompanies = () => async (dispatch) => {
  try {
    dispatch(pending());
    const { data } = await request({
      url: OMS.OMS.CARGO_COMPANIES,
      method: 'get',
    });
    dispatch(fulfilled(data));
  } catch (e) {
    dispatch(rejected(e));
  }
};



// WEBPACK FOOTER //
// ./src/actions/cargoCompanies.js